export const categories = [
    { id: 9, name: "General Knowledge" },
    { id: 10, name: "Literature" },
    { id: 11, name: "Film" },
    { id: 12, name: "Music" },
    { id: 14, name: "Television" },
    { id: 15, name: "Video Games" },
  ];